<template>
	<v-text-field class="right-aligned"
        hide-details dense outlined
        :clearable="!blocked" clear-icon="mdi-close-circle-outline"
        :label="label"
        :ref="name"
        v-model="inputValue"
        :placeholder="label"
        :prefix="prefix[format]"
        :suffix="suffix[format]"
        :readonly="readonly[type]"
        :disabled="readonly[type] || !!blocked"
        @blur="onBlur($event)"
        @changed="onChange($event)"
        @keypress="isAllowed($event)"
        autocomplete="new-password"
    ></v-text-field>
</template>
<script>
export default {
    name: 'DecimalInput',
    props: ['label', 'format', 'name', 'value', 'type', 'blocked'],
    data: () => ({
        prefix: { 'default': '', 'number': '#', 'date': '', 'decimal': '#', 'euro': '#', 'proz': '#' },
        suffix: { 'default': '', 'number': '', 'date': '', 'decimal': '', 'euro': '€', 'proz': '%' },
        readonly: { 'default': false, 'number': false, 'select': false, 'lookup': false, 'datepick': false,
			'kw': false, 'decimal': false, 'calc': true },
        inputValue: null,
    }),
    computed: {
    },
    mounted() {
        /*if(this.reverse[this.format]) {
            let swap = this.prefix
            this.prefix = this.suffix
            this.suffix = swap
        }
        console.log('NumberInput[' + this.name + ']:', this.format, this.reverse[this.format], this.prefix[this.format], this.suffix[this.format])*/
    },
    methods: {
        getNewValue(value) {
            if (!value || value == '') return null
            return parseFloat(value.replace('.', '').replace(',', '.'))

        },
        getInputValue(value) {
            if (!value || value == '') return null
            return parseFloat(value).toString().replace(',', '').replace('.', ',')
            //return parseFloat(value).toLocaleString(['de-DE', 'en'], { style: "decimal", useGrouping: false, minimumFractionDigits: 0, maximumFractionDigits: 3 })
        },
        onBlur(e) {
            this.$emit('changed', this.getNewValue(this.inputValue))
        },
        onChanged(e) {
            //console.log('changed:', e)
        },
        isAllowed(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if(/^[0-9\,\-]+$/.test(char)) return true; // Match with regex 
            else e.preventDefault(); // If not match, don't add to input text
        }
    },
	watch: {
		value (val) {
            //console.log('watcher:', val, this.value, typeof(this.value))
            if(val) this.inputValue = this.getInputValue(this.value)
		},
	},
}
</script>
<style scoped>
.right-aligned >>> input {
    text-align: end
}
</style>